// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"655":"590085d5","787":"5b776329"}[chunkId] + ".chunk.js";
};